module.exports = __webpack_public_path__ + "img/pci_dss.9bc03c5a.png";